import { Accountable } from '@/components/Export/pure/PageManager';
import TransportMode from '@/pure/TransportMode';
import ExportType from '@/pure/ExportType';

export const currentExport = state => state.currentExport;

export const currentExportList = state => state.currentExportList;

export const currentExportLayout = state => state.currentExportLayout;

export const exportActualSites = state => (state.currentExportLayout ? state.currentExportLayout.sites.filter(site => site.type === 1) : []);

export const exportTargetSites = state => (state.currentExportLayout ? state.currentExportLayout.sites.filter(site => site.type === 2) : []);

export const tableOfContent = (state, getters) => {
  const { exportActualSites, exportTargetSites, indexPages, currentExportLayout } = getters;

  let i = 7;
  const mainSynthesisIndex = {
    id: 10,
    name: '0xa1e415',
    page: currentExportLayout && currentExportLayout.type === ExportType.Simplified ? 9 : indexPages + 7,
    transports:
      exportActualSites && exportActualSites.length > 0
        ? exportActualSites[0].transports.map(transport => {
            const transportMode = getTransportMode(transport, currentExportLayout.public_transport_type);
            const transportPageNumber = indexPages + i;

            const sectionNames = transport.sections.map(s => s.name);
            const accounted = Accountable(sectionNames, exportTargetSites.length);

            if (transportMode.key === 'custom' && sectionNames.includes('synthesis')) {
              accounted.forEach(section => section.count++);
            }

            const sections = accounted.map((section, idx) => {
              if (idx === 0 && currentExportLayout.type === ExportType.Simplified) i += indexPages;
              if (idx === 0 && currentExportLayout.type === ExportType.Simplified) i--;
              if (idx === 0 && currentExportLayout.type !== ExportType.Simplified) i++;

              return {
                name: section.key,
                page: (idx === 0 ? i : accounted[idx - 1].count + i) + indexPages,
              };
            });

            i += accounted[accounted.length - 1].count - 1;

            return {
              name: transportMode.key,
              icon: transportMode.icon,
              page: transportPageNumber + 1,
              sections,
            };
          })
        : [],
  };

  const offset = indexPages + (exportActualSites.length > 1 ? i + 1 : 7);
  i = 0;
  const tableOfContent = exportActualSites.map(site => {
    const { id, name } = site;
    const sitePageNumber = i + offset;
    i++;
    const siteTransports = site ? site.transports : [];
    const transports = siteTransports.map(transport => {
      const transportMode = getTransportMode(transport, currentExportLayout.public_transport_type);
      const transportPageNumber = i + 1 + offset;
      const sectionNames = transport.sections.map(s => s.name);
      const accounted = Accountable(sectionNames, exportTargetSites.length);

      if (transportMode.key === 'custom' && sectionNames.includes('synthesis')) {
        accounted.forEach(section => section.count++);
      }

      const sections = accounted.map((section, idx) => {
        if (idx === 0) i++;
        return {
          name: section.key,
          page: (idx === 0 ? i : accounted[idx - 1].count + i) + offset,
        };
      });
      i += accounted[accounted.length - 1].count - 1;
      return {
        name: transportMode.key,
        icon: transportMode.icon,
        page: transportPageNumber,
        sections,
      };
    });

    i++;

    return {
      id,
      name,
      page: sitePageNumber,
      transports,
    };
  });

  const exportTableOfContent = exportActualSites.length > 1 ? [mainSynthesisIndex, ...tableOfContent] : tableOfContent;
  return currentExportLayout && currentExportLayout.type === ExportType.Simplified ? [mainSynthesisIndex] : exportTableOfContent;
};

const getTransportMode = (transport, publicTransportType) => {
  if (transport.type === 1) {
    if (publicTransportType === 2) return TransportMode.find(transportMode => transportMode.key === 'public2025');
    if (publicTransportType === 3) return TransportMode.find(transportMode => transportMode.key === 'public2030');

    if (publicTransportType === 4) return TransportMode.find(transportMode => transportMode.key === 'public2027');
    if (publicTransportType === 5) return TransportMode.find(transportMode => transportMode.key === 'public2031');
  }

  return TransportMode.find(mode => mode.index === transport.type);
};

export const totalPages = state => state.totalPages;

export const indexPages = state => state.indexPages;

export const exportLogo = state => (state.currentExport ? state.currentExport.logo_url : '');

export const globalComment = state => state.globalComment;
